import React from 'react';

const DonorBehaviorFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="6" r="3.25" strokeWidth="1.5" />
    <path
      d="M17 17.5H7.54791C6.89162 17.5 6.27709 17.178 5.90352 16.6384L2.68635 11.9914C2.30315 11.4379 2.42606 10.6805 2.96464 10.2765V10.2765C3.53088 9.85184 4.33628 9.9804 4.74217 10.5602L6.90285 13.6469C7.2771 14.1816 7.88868 14.5 8.54131 14.5H12"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 14.5V13.5C17 12.3954 16.1046 11.5 15 11.5H8.5C7.67157 11.5 7 12.1716 7 13V13C7 13.8284 7.67157 14.5 8.5 14.5H12"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DonorBehaviorFilterIcon;
